export interface StandardTextProps {
  text: string;
}

const StandardText = (props: StandardTextProps) => {
  return <p className="text-base text-text font-normal">{props.text}</p>;
};

export default StandardText;
